import { app } from '../../app.module'
app
  // アカウントの投稿数グラフの表示
  .directive('accountPlays', () => {
    return {
      restrict: 'E',
      template: require('./account-plays.pug')(),
    }
  })
